(function () {
	const _studyTrails = document.querySelectorAll('.js-study-trail');
	
	if (_studyTrails.length === 0) {
		return;
	}
	
	let activeId = document.querySelector('.js-study-trail.is-visible').getAttribute('data-id');
	
	function init() {
		document.addEventListener('click', click);
	}
	
	function click(event) {
		if (!util.hasClass(event.target, 'js-study-trail-nav-button') && !util.hasClass(event.target, 'js-study-trail-prev-button') && !util.hasClass(event.target, 'js-study-trail-next-button')) {
			return;
		}
		
		let _activeTrail = document.querySelector(`.js-study-trail[data-id="${activeId}"]`);
		
		util.removeClass(_activeTrail, 'is-visible');
		_activeTrail.setAttribute('aria-hidden', 'true');
		
		util.removeClass(document.querySelector(`.js-study-trail-nav-button[data-id="${activeId}"]`), 'is-active');
		
		let buttonPressed = false;
		
		if (util.hasClass(event.target, 'js-study-trail-nav-button')) {
			activeId = event.target.getAttribute('data-id');
		} else if (util.hasClass(event.target, 'js-study-trail-prev-button')) {
			if (_activeTrail.previousElementSibling) {
				activeId = _activeTrail.previousElementSibling.getAttribute('data-id');
			} else {
				activeId = _studyTrails[_studyTrails.length - 1].getAttribute('data-id');
			}
			
			buttonPressed = 'prev';
		} else {
			if (_activeTrail.nextElementSibling) {
				activeId = _activeTrail.nextElementSibling.getAttribute('data-id');
			} else {
				activeId = _studyTrails[0].getAttribute('data-id');
			}
			
			buttonPressed = 'next';
		}
		
		_activeTrail = document.querySelector(`.js-study-trail[data-id="${activeId}"]`);
		
		util.addClass(_activeTrail, 'is-visible');
		_activeTrail.setAttribute('aria-hidden', 'false');
		
		if (buttonPressed) {
			_activeTrail.querySelector(`.js-study-trail-${buttonPressed}-button`).focus();
		}
		
		util.addClass(document.querySelector(`.js-study-trail-nav-button[data-id="${activeId}"]`), 'is-active');
	}
	
	init();
}());